import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

const Custom_Button = (props) => {
  return (
    <>
      <Flex
        m={props.m || "0px 0px"}
        bg={props.bg}
        border={props.border || "1px solid #E7E6E8"}
        borderRadius={props.borderRadius || 12}
        justify="center"
        align="center"
        padding={props.padding || "0px 0px"}
        height={props.height || "50px"}
        fontFamily={"Inter"}
        w={props.w || 112}
        cursor={props.cursor || "pointer"}
        onClick={props?.fn}
      >
        <Text
          fontSize={props.fontSize || 18}
          fontFamily={"Inter"}
          letterSpacing={"0.04em"}
          fontWeight={props.fontWeight || "500"}
          display={"flex"}
          alignItems={"center"}
          color={props.color}
        >
          {props?.isIcon && <img src={`${props?.iconPath}`} />}
          <p>{props.action}</p>
        </Text>
      </Flex>
    </>
  );
};

export default Custom_Button;
